<div class="container">
  <div class="content-box">
    <ol class="breadcrumb">
      <li><a routerLink="../setup">{{ 'GLOBAL.CONFIG_ASSISTANT'|translate }}</a></li>
      <li class="active">{{ 'COMPANY_GROUPS.TITLE'|translate }}</li>
    </ol>
    <div class="ag-header sticky">
      <div class="ag-header-title">
        <h3>{{ 'COMPANY_GROUPS.TITLE'|translate }}</h3>
      </div>
      <div class="ag-header-actions">
        <button type="button" class="btn btn-agree"
        [disabled]="processing || !company"
        (click)="create()"><i class="material-symbols-rounded hidden-xs hidden-sm">add</i> {{ 'COMPANY_GROUPS.NEW'|translate }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p>{{ 'COMPANY_GROUPS.HEADING'|translate }}</p>
        <p class="text-info small" [innerHtml]="'COMPANY_GROUPS.INFO'|translate"></p>
      </div>
    </div>

    <div class="loading" *ngIf="!groups">
      <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
    </div>

    <div class="row" *ngIf="groups">
      <div class="col-xs-12">

        <div class="no-data" *ngIf="groups.length === 0">
          <i class="material-symbols-rounded">block</i>
          {{ 'COMPANY_GROUPS.EMPTY'|translate }}
        </div>

        <table class="table table-hover" [sortable]="groups" #tableSortable="tableSortable"
        *ngIf="groups.length > 0">
          <thead>
            <tr>
              <th sortBy="name">{{ 'GLOBAL.NAME'|translate }}</th>
              <th class="hidden-xs">{{ 'INVOICES.DESCRIPTION'|translate }}</th>
              <th sortBy="members_count" class="sap text-right">{{ 'COMPANY_GROUPS.MEMBERS'|translate }}</th>
              <th class="sap"></th>
              <th class="sap"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr-align-center" *ngFor="let group of tableSortable.collection">
              <th>{{ group.name }}</th>
              <td class="hidden-xs text-muted small">{{ group.description }}</td>
              <td class="sap text-right">{{ group.members_count }}</td>
              <td class="sap">
                <a title="{{ 'GLOBAL.EDIT'|translate }}"
                [class.disabled]="processing"
                (click)="edit(group)"><i class="material-symbols-rounded">edit</i></a>
              </td>
              <td class="sap">
                <a title="{{ 'TEMPLATES_VIEW.DELETE'|translate }}"
                [class.disabled]="processing"
                (onConfirm)="delete(group)"
                [confirm-options]="{
                  title: 'COMPANY_GROUPS.DELETE_CONFIRM'|translate,
                  body: 'COMPANY_GROUPS.DELETE_CONFIRM_BODY'|translate,
                  action: 'GLOBAL.YES_DELETE'|translate
                }"><i class="material-symbols-rounded">delete</i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #groupModal>
  <div class="modal-header">
    <button type="button" class="close" [disabled]="processing" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ (group.id ? 'COMPANY_GROUPS.EDIT' : 'COMPANY_GROUPS.NEW')|translate }}</h4>
  </div>
  <div class="modal-body">
    <form id="company-group-form" #groupForm="ngForm" (ngSubmit)="groupForm.valid && submit()">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" [class.has-error]="!isUnique">
            <label class="control-label">{{ 'GLOBAL.NAME'|translate }}</label>
            <input type="text" name="name" class="form-control" autocomplete="off"
            [disabled]="processing"
            maxlength="100"
            [modalFocus]="true" required [(ngModel)]="group.name">
            <p class="help-block small"
            [collapse]="isUnique" [isAnimated]="true">{{ 'COMPANY_GROUPS.NO_UNIQUE'|translate }}</p>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label">
              {{ 'INVOICES.DESCRIPTION'|translate }}
              <small class="text-muted"> ({{ 'GLOBAL.OPTIONAL'|translate }})</small>
            </label>
            <input type="text" name="description" class="form-control" autocomplete="off"
            [disabled]="processing"
            maxlength="255"
            [(ngModel)]="group.description">
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-group">
            <label class="control-label">{{ 'COMPANY_GROUPS.MEMBERS'|translate }}</label>
            <selectize
            [searchURL]="companyService.companySolver([], null, company.id)"
            [(ngModel)]="group.members"
            name="members"
            placeholder="{{ 'GLOBAL.ENTER_COMPANY'|translate }}"></selectize>
            <p class="help-block small">{{ 'COMPANY_GROUPS.MEMBERS_HELP'|translate }}</p>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="closeModal()" [disabled]="processing" class="btn btn-link">{{ 'GLOBAL.CANCEL'|translate }}</button>
    <button type="submit" form="company-group-form" class="btn btn-agree" [disabled]="processing || !groupForm.valid">{{
      (group.id ? 'GLOBAL.SAVE_CHANGES' : 'COMPANY_GROUPS.CREATE')|translate }}</button>
  </div>
</ng-template>
